import Cookie from 'js-cookie';
import { extractTopLevelDomain } from 'shared/services/urlTypeService';

const cookieName = 'cl_culture';

export function useCultureNavigation() {
	const encode = (str: string) =>
		btoa(
			encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) =>
				String.fromCharCode(parseInt(p1, 16))
			)
		);

	const setCultureCookie = (countryName: string) => {
		Cookie.set(cookieName, encode(countryName), {
			domain: extractTopLevelDomain(window.location.href),
		});
	};

	const setCultureAndNavigate = (countryName: string, url: string) => {
		setCultureCookie(countryName);
		window.location.assign(url);
	};

	return {
		setCultureCookie,
		setCultureAndNavigate,
		encode,
	};
}
